const id_sales_refItemOut = {

    message: {
        reject_do_title: "Apakah Anda yakin untuk membatalkan DO?",
        reject_do_text: "Masukkan alasan pembatalan DO.",
    },

    error: {
        reject: "Gagal membatalkan DO OUT.",
    },

    success: {
        reject: "Berhasil membatalkan DO OUT.",
    },
}

export default id_sales_refItemOut;